<template>
  <div>
    <label>Regions</label>
    <div class="checkbox-container">
      <v-checkbox
        v-for="item in items"
        :key="item"
        v-model="selectedRegions"
        :label="item"
        :value="item"
        :outlined="outlined"
        ref="checkboxRefs"
      ></v-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    outlined: {
      default: false
    }
  },
  data() {
    return {
      items: ['North', 'East', 'South', 'West', 'Regional'],
      selectedRegionsText: '',
      selectedRegions: []
    }
  },
  created() {
    this.initializeData()
  },
  watch: {
    value() {
      this.initializeData()
    },
    selectedRegions(val) {
      this.$emit('input', val)
      this.selectedRegionsText = val.map(item => item.name).join(', ')
    }
  },
  methods: {
    initializeData() {
      try {
        if (typeof this.value === 'string' && this.value.trim() !== '') {
          this.selectedRegions = JSON.parse(this.value)
        } else if (Array.isArray(this.value)) {
          this.selectedRegions = this.value
        } else {
          this.selectedRegions = []
        }
      } catch (error) {
        console.error('Error parsing JSON:', error)
        this.selectedRegions = []
      }
    }
  }
}
</script>

<style scoped>
.checkbox-container {
  display: flex;
}
label {
  display: block;
  font-size: 18px;
  font-weight: bold;
  color: #333; /* Adjust color as needed */
}
</style>
